import React from "react";
import { useNavigate } from "react-router-dom";

import { HeaderTitle } from "../../../../components/HeaderTitle";
import { useTranslate } from "../../../../hooks/useTranslate";
import { itemsMatter } from "../../data";
import { IMatter } from "../../interfaces";
import {
  Card,
  Container,
  Content,
  ContentCard,
  BackgroundImage,
} from "./styles";

const List = () => {
  const navigate = useNavigate();
  const { translate } = useTranslate();

  const ItemContentCenter = ({
    description,
    title,
    publishDate,
    img,
    id,
  }: IMatter) => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const imgMatter = require(`../../../../assets/png/${img}`);

    return (
      <Card
        onClick={() => {
          navigate(`/content-center/${id}`);
        }}
      >
        <BackgroundImage src={imgMatter} alt={title} />
        <ContentCard>
          <h4>{translate(`content_center.${title}`)}</h4>
          <p>{translate(`content_center.${description}`)}</p>
          {publishDate && <span>{publishDate}</span>}
        </ContentCard>
      </Card>
    );
  };

  return (
    <Container>
      <HeaderTitle title={translate("content_center.title_list")} />
      <Content>
        {itemsMatter.map((item) => (
          <ItemContentCenter key={item.id} {...item} />
        ))}
      </Content>
    </Container>
  );
};

export { List };
